// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3p6s_","search":"Settings_search__Lhyl5","filter":"Settings_filter__3GbGw"};